
import Teleport from 'vue2-teleport'

export default {
    components: {
        Teleport
    },
    mounted () {
        document.body.style.overflow = 'hidden'
    },
    destroyed () {
        document.body.style.overflow = 'visible'
    }
}
